import isNodeList from '../IsNodeList'
import Helpers from '../Helpers'
import NRequired from '../NRequired'

class FormValidation {
    constructor(forms) {
        if (!isNodeList(forms)) {
            this.forms = [forms]
        }
        else {
            this.forms = Array.from(forms)
        }
    }

    highlightInvalid() {
        this.forms.forEach((form) => {
            form.onsubmit = () => {
                if (typeof (event) !== 'undefined') {
                    if (typeof (event.target) !== 'undefined' && !event.target.hasAttribute('formnovalidate')) {
                        const form = new Helpers(event.target).getClosest('form')
                        form.classList.add('form--highlight-invalid')
                        return form.checkValidity()
                    }
                }
                // safe fallback
                return true
            }
        })
    }

    nRequiredValidity() {
        this.forms.forEach((form) => {
            // find all instances of n-required in this form
            const wrappers = form.getElementsByClassName('n-required')
            Array.from(wrappers).forEach((wrapper) => {
                new NRequired(wrapper)
            })
        })
    }

}

let validation = new FormValidation(document.forms)
validation.highlightInvalid()
validation.nRequiredValidity()



    



